var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#5D83AC",
    cx: 128,
    cy: 128,
    r: 114.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,128 C0,57.3075 57.3075,0 128,0 C198.6925,0 256,57.3075 256,128 C256,198.6925 198.6925,256 128,256 C57.3075,256 0,198.6925 0,128 Z M128,25.5 C71.39075,25.5 25.5,71.39075 25.5,128 C25.5,184.60925 71.39075,230.5 128,230.5 C184.60925,230.5 230.5,184.60925 230.5,128 C230.5,71.39075 184.60925,25.5 128,25.5 L128,25.5 Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4105,166 L147.8905,81.3 C145.83625,78.314 143.3405,75.81825 140.4005,73.81 C137.4605,71.804 133.79625,70.8 129.4105,70.8 C124.83625,70.8 121.05625,71.874 118.0705,74.02 C115.08225,76.168 112.6105,78.594 110.6505,81.3 L50.5905,166 L84.8905,166 L128.8505,103.84 L145.6505,128.62 C147.23625,130.86 148.89225,133.264 150.6205,135.83 C152.34625,138.39825 153.86225,140.52 155.1705,142.2 C152.9305,142.014 150.29225,141.92 147.2605,141.92 L138.5105,141.92 L114.9905,141.92 L97.4905,166 L206.4105,166 L206.4105,166 Z",
    fill: "#F0F0F0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoit);
export default __webpack_public_path__ + "static/media/autoit.f16091a4ebeeaa23c8fe9668322c9e86.svg";
export { ForwardRef as ReactComponent };